/**
 * Handler for filters dropdown
 */

const $ = window.jQuery;

$('.js--toggle-filters').on('click', function () {
  var $t = $(this);
  var $target = $('#' + $t.attr('data-toggle-id'));

  $target.stop().slideToggle(300, function () {
    $(this).css('height', 'auto');
  });

  $t.toggleClass('is--active');
});
